<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg" src="./images/bg.png" alt="" />
      <img class="status" src="./images/status.png" alt="" v-if="status == 0" />
      <img
        class="status"
        src="./images/status-active.png"
        alt=""
        v-if="status == 1"
      />
      <img
        class="status status2"
        src="./images/status.png"
        alt=""
        v-if="status2 == 0"
      />
      <img
        class="status status2"
        src="./images/status-active.png"
        alt=""
        v-if="status2 == 1"
      />
      <div class="top3-box">
        <div
          v-for="(item, index) of topList"
          :key="index"
          class="item"
          :class="`top${index + 1}`"
          @click="toPlayerDetail(item)"
        >
          <template v-if="item && item.userUuid">
            <img :src="item.avatarUrl" class="head-portrait" />
            <div class="user-name">
              {{ item.nikeName }}
            </div>
            <div class="score-box">獲得{{ item.votesNum || '--' }}禮物</div>
          </template>
        </div>
      </div>
      <div class="score-board-box">
        <div
          class="item"
          v-for="(item, index) of list.slice(3, 10)"
          :key="index"
          @click="toPlayerDetail(item)"
        >
          <template v-if="item && item.userUuid">
            <div class="left">
              <span class="index">{{ index + 4 }}</span>
              <img :src="item.avatarUrl" alt="排名頭像" class="" />
              <span class="user-name">{{ item.nikeName }}</span>
            </div>
            <div class="right score-box">
              獲得{{ item.votesNum || '--' }}礼物
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'OnlineVoting',
  data() {
    return {
      list: [],
      activeIndex: 1,
      status: 0,
      status2: 0
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    topList() {
      return this.list && this.list.length
        ? [this.list[1], this.list[0], this.list[2]]
        : [];
    }
  },
  watch: {
    uuid: {
      handler: function(val) {
        if (val) {
          this.getReceiveState(val);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getList() {
      try {
        const { data } = await this.$http.get('/votes/gift/rank', {
          votesType: '20241201'
        });
        this.list = data || [];
      } catch (error) {
        console.log(error);
      }
    },
    async getReceiveState() {
      try {
        const { data } = await this.$http.get('/votes/gift/has');
        this.status = data[1000] || 0;
        this.status2 = data[3000] || 0;
      } catch (error) {
        this.status = 1;
      }
    },
    toPlayerDetail(userInfo) {
      const { userUuid } = userInfo;
      if (!userUuid) return;
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #fff7e8;
  overflow: auto;
  text-align: center;
  background-image: url('./images/web-bg.png');
  background-size: 100% 100%;
  .main {
    position: relative;
    display: inline-block;
    width: 750px;
    text-align: left;
    > .bg {
      width: 100%;
    }
    .status {
      position: absolute;
      width: dPx(61);
      height: auto;
      top: dPx(571);
      left: dPx(281);
    }
    .status2 {
      top: dPx(735);
    }
    .top3-box {
      position: absolute;
      display: flex;
      justify-content: space-between;
      position: absolute;
      width: dPx(253);
      height: dPx(134);
      left: dPx(61);
      top: dPx(971);

      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 24px;
        flex: none;
        color: #363a52;
        width: dPx(71);
        text-align: center;
        img {
          border-radius: 50%;
          object-fit: cover;
          width: dPx(71);
          height: dPx(71);
          background-color: #d9d9d9;
          object-fit: cover;
        }
        .user-name {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 100%;
          font-weight: 400;
          font-size: dPx(13);
          height: dPx(18);
          line-height: dPx(18);
        }
        .score-box {
          height: dPx(15);
          line-height: dPx(15);
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 100%;
          font-weight: 400;
          font-size: dPx(11);
          text-align: center;
        }
        &.top1,
        &.top3 {
          margin-top: dPx(23);
        }
      }
    }
    .score-board-box {
      position: absolute;
      top: dPx(1133);
      left: dPx(61);
      width: dPx(253);
      overflow: auto;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
      &::-webkit-scrollbar {
        display: none;
      }
      .item {
        display: flex;
        align-items: center;
        width: 100%;
        margin-bottom: dPx(4);
        color: #363a52;
        padding: 0;
        font-size: dPx(13);
        height: dPx(42);
        background-color: #ffedee;
        border-radius: dPx(7);
        .score-box {
          height: dPx(14);
          display: flex;
          align-items: center;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 100%;
          font-weight: 400;
          font-size: dPx(11);
        }
        .left,
        .right {
          display: flex;
          align-items: center;
        }
        .right {
          margin-left: 30px;
        }
        .left {
          .index {
            margin-left: dPx(14);
            margin-right: dPx(6);
            width: dPx(14);
            text-align: left;
          }
          img {
            width: dPx(28);
            height: dPx(28);
            background: #d9d9d9;
            border-radius: 50%;
            margin-right: dPx(8);
            object-fit: cover;
          }
          .user-name {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: 174px;
          }
        }
      }
    }
  }
}
</style>
